var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#50BD89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5009 23.5L14.5842 20.5833C14.2592 20.2583 13.7426 20.2583 13.4176 20.5833C13.0926 20.9083 13.0926 21.425 13.4176 21.75L16.9092 25.2417C17.2342 25.5667 17.7592 25.5667 18.0842 25.2417L26.9176 16.4167C27.2426 16.0917 27.2426 15.575 26.9176 15.25C26.5926 14.925 26.0759 14.925 25.7509 15.25L17.5009 23.5Z",
    fill: "#50BD89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDone);
export default __webpack_public_path__ + "static/media/circleDone.4dc20384.svg";
export { ForwardRef as ReactComponent };